import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { AppNavigationContainer } from "./navigation";

import "./i18n/i18n";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // default - queries will be refetched if same query key is mounted again (by same or another component)
      // after 60s
      staleTime: 60 * 1000,
    },
  },
});

export const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AppNavigationContainer />
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
};
